import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.div`
  .checkBox-Component {
    color: ${palette("formInputElement", 0)};
    font-size: ${size("p0")};
    line-height: 20px;
    font-size: 15px;
    margin: 10px 0;
    padding: 0px 10px 0px 24px;
    border-radius: 5px;
  }

  .checkBox-Component input {
    margin: 2px 0px 0px -22px;
    position: absolute;
  }

  .checkBox-Component ul {
    list-style: initial;
    margin: 6px 0 0 20px;
    // color: ${palette("formInputElement", 0)};
  }

  .checkBox-Component ul li {
    margin-bottom: 6px;
  }

  .required {
    color: ${palette("error", 3)};
    border: 2px solid ${palette("error", 4)};
  }

  .checkBox-InformationContainer {
    text-align: left;
  }

  .checkBox-InformationContainer:hover {
    cursor: pointer;
  }
  
  .checkBox-Input:focus-within {
    outline: 1px dotted #212121;
    outline: 5px auto -webkit-focus-ring-color;
  }

  .checkBox-Label {
    margin-right: 3px;
    float: left;
    font-weight: bold;
  }
  .checkBox-Label-Optional {
    padding-left: 6px;
    font-size: ${size("p3")};
    color: ${palette("grayscale", 17)};
    font-weight: 700;
  }
`;

export default Wrapper;
